/* eslint-disable max-params */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Input } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import styleObj from '../../../styles/EnhancedDataTable/EnhanceTableStyles';
import DateRangePickerFilterComponent from './DateFilter/DateRangePickerFilterComponent';
import DatePickerFilterComponent from './DateFilter/DatePickerFilterComponent';

export const getFilters = (
  headerToDisplay,
  filters,
  tdStyleObject,
  setFilter,
  onKeyPress,
  tableNm) => {
  const tempMarkup = [];
  filters.map((filter, colIdx) => {
    const header = headerToDisplay[colIdx];
    if (header) {
      tempMarkup.push(
        <td id={`${tableNm}-filter-cell-${header.id}`} css={tdStyleObject}>
          <div id={`${tableNm}-filter-${header.id}-div`} css={styleObj['.filterInput']}>
            <FilterComponent
              header={header}
              filters={filters}
              colIdx={colIdx}
              filter={filter}
              setFilter={setFilter}
              onKeyPress={onKeyPress}
              tableNm={tableNm}
            />
          </div>
        </td>
      );
    }
    return null;
  });
  return tempMarkup;
};

const FilterComponent = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    header, filters, colIdx, filter, setFilter, onKeyPress, tableNm,
  } = props;

  switch (header.type) {
    case 'date-range':
      return (
        <DateRangePickerFilterComponent
          header={header}
          filters={filters}
          colIdx={colIdx}
          filter={filter}
          setFilter={setFilter}
          onKeyPress={onKeyPress}
          tableNm={tableNm}
          isDisable={header.isDisableFilter}
        />
      );
    case 'date':
      return (
        <DatePickerFilterComponent
          header={header}
          filters={filters}
          colIdx={colIdx}
          filter={filter}
          setFilter={setFilter}
          onKeyPress={onKeyPress}
          tableNm={tableNm}
          isDisable={header.isDisableFilter}
        />
      );

    case '':
    case undefined:
    default:
      return (
        <Input
          id={`${tableNm}-filter-${header.id}-input`}
          key={`${tableNm}-filter-${header.id}-input`}
          value={filter}
          onChange={(e) => {
            const newFilters = [...filters];
            newFilters[colIdx] = e.target.value;
            setFilter(newFilters);
          }}
          onKeyPress={(e) => {
            onKeyPress(e);
          }}
          placeholder={header.label}
          disabled={header.isDisableFilter}
        />
      );
  }
};

FilterComponent.propTypes = {
  header: PropTypes.shape({
    type: PropTypes.string,
    isDisableFilter: PropTypes.bool,
    id: PropTypes.number,
    label: PropTypes.string,
  }),
};
